import React from 'react'

import Check from 'components/Form/Check'
import Input from 'components/Form/Input'
import Select from 'components/Form/Select'
import useI18n from 'hooks/useI18n'
import {
  CatalogActions,
  CatalogDescription,
  CatalogHeader,
  CatalogList,
  CatalogMessage,
  CatalogRow,
  CatalogTitle,
  ClearButton,
  FilterGrid,
  SelectVisibleButton,
  SelectedCount,
  TypeLabel,
  AccessStatus,
  LockIcon,
} from './styled'

const keyFor = item => `${item?.contentUid}:${item?.contentDocumentId}`

export default function ContentLockSelector({
  catalog,
  loading,
  error,
  query,
  type,
  types,
  selected = [],
  setQuery,
  setType,
  onChange,
}) {
  const { t } = useI18n()
  const selectedKeys = new Set((selected || []).map(keyFor))

  const toggle = item => {
    const key = keyFor(item)
    onChange(selectedKeys.has(key)
      ? selected.filter(entry => keyFor(entry) !== key)
      : [...selected, {
        contentUid: item.contentUid,
        contentDocumentId: item.contentDocumentId,
        accessState: 'available',
      }])
  }

  const selectVisible = () => onChange([
    ...selected,
    ...(catalog || []).filter(item => !selectedKeys.has(keyFor(item))).map(item => ({
      contentUid: item.contentUid,
      contentDocumentId: item.contentDocumentId,
      accessState: 'available',
    })),
  ])

  return (
    <div>
      <CatalogHeader>
        <div>
          <CatalogTitle>{t('staff_essentials_invites_locked_content_title')}</CatalogTitle>
          <SelectedCount>{selected.length} {t('staff_essentials_invites_locked_content_selected')}</SelectedCount>
        </div>
        <CatalogActions>
          <SelectVisibleButton type="button" onClick={selectVisible} disabled={loading || !(catalog || []).length}>
            {t('staff_essentials_invites_locked_content_select_visible')}
          </SelectVisibleButton>
          <ClearButton type="button" onClick={() => onChange([])} disabled={!selected.length}>
            {t('staff_essentials_invites_locked_content_clear')}
          </ClearButton>
        </CatalogActions>
      </CatalogHeader>
      <CatalogDescription>{t('staff_essentials_invites_locked_content_description')}</CatalogDescription>
      <FilterGrid>
        <Input
          type="search"
          placeholder={t('staff_essentials_invites_locked_content_search')}
          value={query}
          onChange={event => setQuery(event.target.value)}
        />
        <Select
          placeholder={t('staff_essentials_invites_locked_content_filter')}
          value={type}
          onChange={setType}
          options={[{ id: '', title: t('staff_essentials_invites_locked_content_all_types') }, ...(types || []).map(item => ({ id: item.type, title: item.label }))]}
        />
      </FilterGrid>
      <CatalogList aria-busy={loading}>
        {loading ? <CatalogMessage>{t('staff_essentials_invites_locked_content_loading')}</CatalogMessage> : null}
        {!loading && error ? <CatalogMessage error>{error}</CatalogMessage> : null}
        {!loading && !error && !catalog.length ? <CatalogMessage>{t('staff_essentials_invites_locked_content_empty')}</CatalogMessage> : null}
        {!loading && !error ? catalog.map(item => (
          <CatalogRow key={keyFor(item)} $allowed={selectedKeys.has(keyFor(item))}>
            <Check
              label={item.title}
              checked={selectedKeys.has(keyFor(item))}
              onChange={() => toggle(item)}
            />
            <AccessStatus $allowed={selectedKeys.has(keyFor(item))}>
              {selectedKeys.has(keyFor(item)) ? null : (
                <LockIcon icon="content-locked" nomargin alt="" aria-hidden="true" />
              )}
              {t(selectedKeys.has(keyFor(item))
                ? 'staff_essentials_invites_content_available'
                : 'staff_essentials_invites_content_locked')}
            </AccessStatus>
            <TypeLabel>{item.typeLabel}</TypeLabel>
          </CatalogRow>
        )) : null}
      </CatalogList>
    </div>
  )
}
